// Address-box helpers for airport suggestions. The server returns airport suggestions FIRST ({airport: true, code, lat, lng, exact}); these decide what the box does.

// A three-letter airport code typed exactly ("jfk") is chosen on its own; names ("newark") wait for a tap, Enter, or leaving the box.
export const isTypedCode = (typed, suggestion) =>
  !!suggestion && suggestion.airport === true && suggestion.exact === true && /^[a-z]{3}$/i.test(String(typed || '').trim());

export const wasChosenAlready = (typed, lastChosenText) => !!lastChosenText && String(typed || '').trim() === String(lastChosenText).trim();

// What to show when the list is empty because a lookup failed (nothing is shown when the visitor simply typed something unusual).
export const failureHint = (status, googleOk) => {
  if (status === 401) return 'Your session has expired. Please sign in again to get address suggestions.';
  if (status === 429) return 'Too many address lookups. Wait a few seconds and keep typing.';
  if (status >= 500) return 'Address suggestions are unavailable right now. You can type the full address.';
  if (googleOk === false) return 'Address suggestions are limited right now. Airports still work; otherwise type the full address.';
  return '';
};

export const suggestionText = (s) => (s && s.description) || '';
